import { render, staticRenderFns } from "./TesteAntibioticoATB.vue?vue&type=template&id=058c2042&scoped=true"
import script from "./TesteAntibioticoATB.vue?vue&type=script&lang=js"
export * from "./TesteAntibioticoATB.vue?vue&type=script&lang=js"
import style0 from "./TesteAntibioticoATB.vue?vue&type=style&index=0&id=058c2042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058c2042",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
